import React from "react";
import { styled } from "@mui/material";
export const Quote = ({ author, children }) => {
    return (React.createElement("figure", { style: { margin: 0 } },
        React.createElement(Blockquote, null, children),
        !!author && React.createElement(Author, null,
            "\u2013 ",
            author)));
};
const Author = styled("figcaption")(({ theme }) => ({
    ...theme.typography.body1,
    textAlign: "center",
    paddingTop: theme.spacing(3),
}));
const Blockquote = styled("blockquote")(({ theme }) => ({
    fontSize: "2.5rem",
    fontStyle: "oblique",
    fontWeight: 400,
    hyphens: "manual",
    letterSpacing: "0.02em",
    lineHeight: 1,
    margin: "0 auto",
    maxWidth: "100%",
    padding: 0,
    textAlign: "center",
    "&:before": {
        content: "'„'",
    },
    "&:after": {
        content: "'“'",
    },
    [theme.breakpoints.up("sm")]: {
        fontSize: "2.75rem",
    },
    [theme.breakpoints.up("md")]: {
        maxWidth: "75%",
        fontSize: "3rem",
    },
    [theme.breakpoints.up("xl")]: {
        fontSize: "3.25rem",
    },
}));
//# sourceMappingURL=quote.js.map